import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "@/lib/utils/cn";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-none font-sans text-[12px] font-semibold uppercase tracking-[0.18em] transition-[background-color,color,box-shadow,border-color,gap] duration-300 focus-visible:outline-none focus-visible:shadow-focus disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "border border-primary bg-primary text-navy hover:border-primary-deep hover:bg-primary-deep",
        outline:
          "border border-line bg-transparent text-ink hover:border-primary hover:text-primary-deep",
        navy: "border border-primary bg-primary text-navy hover:border-white hover:bg-white",
        navyOutline:
          "border border-white/25 bg-transparent text-white hover:border-white/60 hover:bg-white/5",
        ghost: "text-ink hover:text-primary-deep",
        link: "text-ink underline underline-offset-4 hover:text-primary-deep",
      },
      size: {
        default: "h-12 px-6",
        sm: "h-11 px-5 text-[11px]",
        lg: "h-14 px-8",
        icon: "h-12 w-12",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

export type ButtonProps = ComponentProps<"button"> & VariantProps<typeof buttonVariants>;

export function Button({ className, variant, size, type = "button", ...props }: ButtonProps) {
  return (
    <button type={type} className={cn(buttonVariants({ variant, size }), className)} {...props} />
  );
}
